module.exports = __webpack_public_path__ + "static/media/Oluremi Tinuolu-Gabriel.d541c5b0.JPG";